import axios from "axios";
import config from "../config";
import { bindActionCreators } from "redux";
import Router, { getCurrentUrl } from "preact-router";

let apiURL = config("API_URL");
const allowedRegions = ["au", "nz"];

const ContentServices = {
  async getCountry() {
    let response = await axios.get(`${apiURL}/content/getCountry`);
    return response.data;
  },

  async getEntry(entry, locale) {
    return axios.get(`${apiURL}/content/entry`, {
      params: {
        entryId: entry,
        locale: locale
      }
    });
  },

  async getAsset(assetId, locale) {
    return axios.get(`${apiURL}/content/asset`, {
      params: {
        assetId: assetId,
        locale: locale
      }
    });
  },

  async getComponentContent(contentID, locale) {
    return axios.get(`${apiURL}/content/component`, {
      params: {
        contentString: contentID,
        locale: locale.toUpperCase()
      }
    });
  },

  async getUrl(url, locale) {
    const splitUrl = url.split("/");
    if (splitUrl[1].length === 2) {
      splitUrl[1] = allowedRegions.includes(locale)
        ? locale
        : allowedRegions[0];
      return splitUrl.join("/");
    }
    return `${locale.toLowerCase()}${url}`;
  }
};

export default ContentServices;
